import roomimg1 from "../Assets/Images/roomimg.png"
import room1 from "../Assets/Images/room1.png"
import room2 from "../Assets/Images/room2.png"
import room3 from "../Assets/Images/room3.png"
import { GiIndiaGate } from "react-icons/gi";
import { GiMedievalGate } from "react-icons/gi";
import { RiAncientGateFill } from "react-icons/ri";
import { FaFemale } from "react-icons/fa";
import { FaPerson } from "react-icons/fa6";

export const Rooms=[
  {
    image:roomimg1,
    name:"Ramini House",
    location:"Bhubaneswar",
    logo:<FaPerson className="h-[20px] lg:h-[25px] w-[20px] lg:w-[25px]"/>,
    gender:"Men's PG",
    type:"Attached Washroom",
    price: "₹7,799/mo*"
  },
  {
    image:roomimg1,
    name:"Ramini House",
    location:"Bhubaneswar",
    logo:<FaFemale className="h-[20px] lg:h-[25px] w-[20px] lg:w-[25px]"/>,
    gender:"Women's PG",
    type:"Separate Washroom",
    price: "₹7,799/mo*"
  },
  {
    image:roomimg1,
    name:"Ramini House",
    location:"Bhubaneswar",
    gender:"Women's PG",
    logo:<FaFemale className="h-[20px] lg:h-[25px] w-[20px] lg:w-[25px]"/>,
    type:"Attached Washroom",
    price: "₹7,799/mo*"
  },
  {
    image:roomimg1,
    name:"Ramini House",
    location:"Bhubaneswar",
    gender:"Men's PG",
    logo:<FaPerson className="h-[20px] lg:h-[25px] w-[20px] lg:w-[25px]"/>,
    type:"Attached Washroom",
    price: "₹7,799/mo*"
  },
  {
    image:roomimg1,
    name:"Ramini House",
    location:"Bhubaneswar",
    gender:"Men's PG",
    logo:<FaPerson className="h-[20px] lg:h-[25px] w-[20px] lg:w-[25px]"/>,
    type:"Separate Washroom",
    price: "₹7,799/mo*"
  }
]


export const occupancy_details=[
  {
    number:3,
    occupancy:"Triple Occupancy",
    discount_Price:"₹9,899/mo*",
    real_price:"₹7,799/mo*"
  },
  {
    number:4,
    occupancy:"Quadruple Occupancy",
    discount_Price:"₹10,899/mo*",
    real_price:"₹9,799/mo*"
  }
]


export const similar_properties=[
  {
    image:room1,
    name:"Ramini House",
    gender:"Men's",
    price:"₹7,799/mo*",
    off:"Upto 10% OFF"
  },
  {
    image:room2,
    name:"Ramini House",
    gender:"Men's",
    price:"₹7,799/mo*",
    off:"Upto 10% OFF"
  },
  {
    image:room3,
    name:"Ramini House",
    gender:"Men's",
    price:"₹7,799/mo*",
    off:"Upto 10% OFF"
  }
]

export const states=[
  {
    image:<GiIndiaGate/>,
    state_name:"Delhi",
  },
  {
    image:<GiMedievalGate/>,
    state_name:"Hyderabad",
  },
  {
    image:<RiAncientGateFill/>,
    state_name:"Odisha",
  },
  {
    image:<GiIndiaGate/>,
    state_name:"Coimbatore",
  },
  {
    image:<RiAncientGateFill/>,
    state_name:"Mumbai",
  },
  {
    image:<GiMedievalGate/>,
    state_name:"Miyamar",
  },
  {
    image:<GiIndiaGate/>,
    state_name:"Rajkot",
  },
]